<template functional>
    <div
        v-bind="data.attrs"
        :class="['modal-line-secondary', data.staticClass, data.class]"
        :style="[data.staticStyle, data.style]"
    >
        <slot />
    </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
    name: 'ModalLineSecondary',
});
</script>

<style>
.modal-line-secondary {
    font-size: 14px;
    margin-bottom: 30px;
}
</style>
